import {Input} from "@angular/core";

/**
 * Базовый класс директивы шапки для выноса общего функцонала
 */
export class DxPageHeaderBaseDirective {
  /**
   * Уникальный строковый идентификатор элемента шапки.
   * @name _ident
   * @type {string}
   */
  private _ident: string;

  get ident(): string {
    return this._ident;
  }

  @Input()
  set ident(value: string) {
    this._ident = value;
  }
}
